import { useState, useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import axios from "axios";
import { FaEdit, FaTrash } from "react-icons/fa";
import { toast } from "react-toastify";

const API = process.env.REACT_APP_API_URL;

function Expenses() {
  const [isOpen, setIsOpen] = useState(false);
  const [expenses, setExpenses] = useState([]);

  // modal
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  // form
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [editId, setEditId] = useState(null);

  // search
  const [search, setSearch] = useState("");

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9;

  useEffect(() => {
    document.title = "Expenses | Admin Panel";
    fetchExpenses();
  }, []);

const fetchExpenses = async () => {
  try {
    const token = localStorage.getItem("token");

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.get(`${API}/expenses`, config);
    setExpenses(res.data);
  } catch (err) {
    console.log(err);

    if (err.response) {
      if (err.response?.status === 401) {
        localStorage.removeItem("token");
        window.location.href = "/login";
      }
    }
  }
};

  // filter
  const filteredExpenses = expenses.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase())
  );

  // pagination logic
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentItems = filteredExpenses.slice(indexOfFirst, indexOfLast);

  const totalPages = Math.ceil(filteredExpenses.length / itemsPerPage);

  const changePage = (page) => {
    setCurrentPage(page);
  };

  // ADD / UPDATE
const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const token = localStorage.getItem("token");

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    if (isEdit && editId) {
      await axios.put(
        `${API}/expenses/${editId}`,
        {
          name,
          price,
        },
        config
      );
      toast.success("Expense updated 🎉");
    } else {
      await axios.post(
        `${API}/expenses`,
        {
          name,
          price,
        },
        config
      );
      toast.success("Expense added 🚀");
    }

    fetchExpenses();
    closeModal();
  } catch (err) {
    console.log(err);

    if (err.response) {
      if (err.response?.status === 401) {
        toast.error("Unauthorized token");
        localStorage.removeItem("token");
        window.location.href = "/login";
      }

      if (err.response.data.message) {
        toast.error(err.response.data.message);
      } else if (err.response.data.errors) {
        const errors = err.response.data.errors;

        Object.values(errors).forEach((messages) => {
          toast.error(messages[0]);
        });
      } else {
        toast.error("Validation failed ❌");
      }
    } else {
      toast.error("Server not responding ❌");
    }
  }
};
  // DELETE
const handleDelete = async (id) => {
  if (!window.confirm("Delete this expense?")) return;

  try {
    const token = localStorage.getItem("token");

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    await axios.delete(`${API}/expenses/${id}`, config);

    toast.success("Deleted ❌");
    fetchExpenses();
  } catch (err) {
    console.log(err);

    if (err.response) {
      const status = err.response.status;
      const message = err.response.data?.message;

      if (status === 401) {
        toast.error("Unauthorized token ❌");
        localStorage.removeItem("token");
        window.location.href = "/login";
      } else if (status === 422) {
        toast.error(message || "Cannot delete this expense");
      } else if (status === 404) {
        toast.error(message || "Expense not found");
      } else {
        toast.error(message || "Delete failed");
      }
    } else {
      toast.error("Server not responding ❌");
    }
  }
};

  // edit
  const handleEdit = (item) => {
    setName(item.name);
    setPrice(item.price);
    setEditId(item.id);
    setIsEdit(true);
    setShowModal(true);
  };

  const openAddModal = () => {
    setName("");
    setPrice("");
    setIsEdit(false);
    setShowModal(true);
  };

  const closeModal = () => {
    setName("");
    setPrice("");
    setEditId(null);
    setIsEdit(false);
    setShowModal(false);
  };

  return (
    <div className="flex min-h-screen bg-gray-100">

      <Sidebar isOpen={isOpen} toggleSidebar={() => setIsOpen(!isOpen)} />

      <div className="flex-1 flex flex-col">

        <Header toggleSidebar={() => setIsOpen(!isOpen)} />

        <main className="p-6">

          {/* TOP */}
          <div className="flex flex-col md:flex-row justify-between gap-4 mb-6">

            <h2 className="text-2xl font-bold">Expenses</h2>

            <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">

              <input
                className="px-4 py-2 border rounded-lg w-full md:w-64"
                placeholder="Search..."
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setCurrentPage(1); // reset page
                }}
              />

              <button
                onClick={openAddModal}
                className="bg-blue-600 text-white px-4 py-2 rounded"
              >
                + Add
              </button>

            </div>

          </div>

          {/* CARDS */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">

            {currentItems.map((item) => (
              <div
                    key={item.id}
                    className="bg-white p-5 rounded-xl shadow hover:shadow-xl transition"
                  >

                <h3 className="font-bold">{item.name}</h3>

                <p className="text-gray-500">AED {item.price}</p>

                <div className="flex justify-between mt-4">

                  <button
                    onClick={() => handleEdit(item)}
                    className="text-blue-600 flex items-center gap-1"
                  >
                    <FaEdit /> Edit
                  </button>

                  <button
                    onClick={() => handleDelete(item.id)}
                    className="text-red-600 flex items-center gap-1"
                  >
                    <FaTrash /> Delete
                  </button>

                </div>

              </div>
            ))}

          </div>

          {/* PAGINATION */}
          <div className="flex justify-center mt-8 gap-2">

            <button
              disabled={currentPage === 1}
              onClick={() => changePage(currentPage - 1)}
              className="px-3 py-1 border rounded disabled:opacity-50"
            >
              Prev
            </button>

            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i}
                onClick={() => changePage(i + 1)}
                className={`px-3 py-1 border rounded ${
                  currentPage === i + 1 ? "bg-blue-600 text-white" : ""
                }`}
              >
                {i + 1}
              </button>
            ))}

            <button
              disabled={currentPage === totalPages}
              onClick={() => changePage(currentPage + 1)}
              className="px-3 py-1 border rounded disabled:opacity-50"
            >
              Next
            </button>

          </div>

        </main>
      </div>

      {/* MODAL */}
      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">

          <div className="bg-white w-full max-w-md p-6 rounded-2xl shadow-2xl">

            <h2 className="text-xl font-bold mb-4">
              {isEdit ? "Update Expense" : "Add Expense"}
            </h2>

            <form onSubmit={handleSubmit} className="space-y-4">

              <input
                className="w-full border p-3 rounded-lg"
                placeholder="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />

              <input
                className="w-full border p-3 rounded-lg"
                placeholder="Price"
                type="number"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                required
              />

              <div className="flex gap-2">

                <button
                  type="button"
                  onClick={closeModal}
                  className="w-full bg-gray-300 p-2 rounded"
                >
                  Cancel
                </button>

                <button className="w-full bg-blue-600 text-white p-2 rounded">
                  {isEdit ? "Update" : "Save"}
                </button>

              </div>

            </form>

          </div>

        </div>
      )}

    </div>
  );
}

export default Expenses;